import { Box } from '@factorialco/deprecated-design-system'

import MoneyField from 'modules/core/components/MoneyField'
import TextField from 'modules/core/components/TextField'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import Document from 'modules/documents/store/models/Document'

import Documents from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/BasePendingApprovals/components/Documents'
import type { CollapseContentData } from 'modules/notifications/pages/RequestsPage/RequestItems/RequestItem/CustomContent/PendingApprovals/ExpensesApprovals/types'
import Link from './Link'

interface Props {
  collapseContentData: CollapseContentData
}

const PerDiemRightBlock = ({
  collapseContentData: { amount, currency, perDiem, ...collapseContentData },
}: Props) => {
  const hasFilesAttached = !!perDiem?.files?.length

  return (
    <Box width="full" gap="s24">
      <Box width="full">
        <TextField
          readonly
          label={i18n.t('dashboard.todo.approvals.expenses.category')}
          value={perDiem?.category?.name}
        />
      </Box>
      <Box flexDirection="row" gap="s24">
        <Box width="full">
          <TextField
            label={i18n.t('expenses_v2.forms.fields.from.label')}
            value={perDiem?.from || ''}
            readonly
          />
        </Box>
        <Box width="full">
          <TextField
            label={i18n.t('expenses_v2.forms.fields.to.label')}
            value={perDiem?.to || ''}
            readonly
          />
        </Box>
      </Box>
      <Box flexDirection="row" gap="s24">
        <Box width="full">
          <MoneyField
            label={i18n.t('expenses_v2.per_diem.per_diem_rates.table.total')}
            value={String(amount ? fromCents(Number(amount)) : null)}
            currency={currency}
            readonly
          />
        </Box>
        <Box width="full">
          <TextField
            label={i18n.t('dashboard.todo.approvals.expenses.date')}
            value={dateBackendDateTimeToUI(collapseContentData?.effectiveOn)}
            readonly
          />
        </Box>
      </Box>

      {hasFilesAttached && (
        <Documents
          documents={perDiem.files.map(
            (file) =>
              new Document({ id: file.id, file: file.url, filename: file.filename, url: file.url })
          )}
        />
      )}

      <Link resourceId={collapseContentData.id} />
    </Box>
  )
}

export default PerDiemRightBlock
